module.exports = (function (H) {
	H.wrap(H.Chart.prototype, 'redrawRegressionLine', function () {
		return;
	});
});
